export default __webpack_public_path__ + "ce72baa3bdcdb25d7acc9de040c0ae56.svg";